import { modelFactory } from '~/base/ModelFactory';

import RefreshTokenApiRepository from './RefreshTokenApiRepository';
import { RefreshTokenDto } from './dto/RefreshTokenDto';
import RefreshLocalRepository from './models/RefreshTokenLocalRepository';
import { RefreshTokenModel } from './models/RefreshTokenModel';

export default class RefreshTokenService {
  tokenApi: RefreshTokenApiRepository;
  tokenLocal: RefreshLocalRepository;

  constructor() {
    this.tokenApi = new RefreshTokenApiRepository();
    this.tokenLocal = new RefreshLocalRepository();
  }

  // API

  refreshAccessToken = async (dto: RefreshTokenDto): Promise<RefreshTokenModel> => {
    const { data } = await this.tokenApi.refreshAccessToken(dto);

    return modelFactory.create(RefreshTokenModel, data.data);
  };

  // LOCAL

  get = () => {
    return this.tokenLocal.get();
  };

  set = (token: string): void => {
    if (import.meta.env.DEV) {
      this.tokenLocal.set(token);
    }
  };

  delete = () => {
    this.tokenLocal.remove();
  };
}
